<app-full-page-message
    *ngIf="businessId && businessId.length > 5 && !localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)" />
<div
    *ngIf="!businessId || businessId.length < 5 || localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.common && localService.languageContent.custom_label_print">
        <div *ngIf="tabs" class="freeze_height">
            <app-tab [tabs]="tabs" [(selectedKey)]="selectedTabKey" [isShowRefresh]="true" (onRefresh)="onLoad()"
                (onTabSelected)="onSetSelectedTabItems()" />
        </div>
        <div *ngIf="businessId && businessId.length > 0 && wrapper">
            <div class="banner center" style="max-width:600px;">
                <div class="row freeze_height">
                    <div class="col-6">
                        <button class="button_icon button_icon_color icon_adjust" (click)="onLoad()"
                            style="top: 0px !important;">refresh</button>
                        <button class="button_icon button_icon_color icon_adjust" (click)="onAction(1)"
                            style="top: 0px !important;">add</button>
                    </div>
                    <div class="col-6" style="text-align: right;">
                        <div style="float: right;width: 300px;">
                            <ngx-select [isFocused]="true"
                                [placeholder]="localService.languageContent.custom_label_print.select_language"
                                [(ngModel)]="selectedLanguageId" [noAutoComplete]="true"
                                [items]="localService.languagesEquivalent" [optionValueField]="'v1'"
                                [optionTextField]="'v3'" (select)="onLoad()">
                            </ngx-select>
                        </div>
                    </div>
                </div>
                <div class="row freeze_height">
                    <div class="col-6">
                        <label style="font-weight: normal; margin-left: 15px;">
                            <input type="checkbox" [(ngModel)]="isShowOnlyPinned" (change)="onLoad()" />
                            <span
                                class="normal_color">{{localService.languageContent.custom_label_print.show_pinned}}</span>
                        </label>
                    </div>
                    <div class="col-6">
                        <label style="font-weight: normal; margin-left: 15px;">
                            <input type="checkbox" [(ngModel)]="isShowDeleted" (change)="onLoad()" />
                            <span
                                class="normal_color">{{localService.languageContent.custom_label_print.show_deleted}}</span>
                        </label>
                    </div>
                </div>
                <div class="custom_rows_body" style="margin-top: 10px;"
                    [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
                    <div *ngIf="selectedItems.length == 0" style="height: calc(100vh - 200px);" class="center">
                        {{localService.languageContent.common.no_data}}
                    </div>
                    <div class="row styled_row" *ngFor="let item of selectedItems; index as idx">
                        <div class="col-2">
                            <span class="en" style="float: left; margin-top: 6px;">{{idx+1}}.</span>
                            <button class="button_icon icon_adjust" style="float: left;"
                                title="{{item.isSelected ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                                (click)="onActiveInactiveStatus(item.key)"
                                [ngStyle]="{'color': item.isSelected ? 'indianred' : 'green' }">{{item.isSelected
                                ?
                                "cancel" : "restore"}}</button>
                        </div>
                        <div class="col-10">
                            <button class="plain_btn" (click)="onAction(1,item.key)">
                                <span class="en" style="color: darkgray;">{{item.v2}}&nbsp;</span>
                                <span>{{item.v4 ?? item.v1}}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="businessId && businessId.length > 0 && wrapper">
        <app-custom-label-print-config [(isOpenPopup)]="isOpenCustomLabelConfig" [businessId]="businessId"
            [printerTemplateId]="selectedTabKey" [languageId]="selectedLanguageId" [id]="selectedId"
            [replaceLabels]="wrapper.replaceLabels" (onClose)="onLoad()" [isCanEdit]="isCanEdit"
            [customFields]="customFields" [customLabelInputTypes]="wrapper.customLabelInputTypes" />
    </div>
</div>
<span style="display: none;">
    <button class="after_access_check" (click)="onLoad(true)">After Access Check</button>
</span>